import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { PaginatedCompanies } from '../../domain/models/company/paginated-companies';
import { Observable } from 'rxjs';
import { CompanyWithFiles } from '../../domain/models/company/company-with-files';
import { CompanyStats } from '../../domain/models/company/company-stats';
import { SearchCompanies } from '../../domain/models/company/search-companies';

@Injectable({
  providedIn: 'root',
})
export class CompanyService {
  private readonly http = inject(HttpClient);
  private baseUrl = environment.apiUrl;

  getCompanyById(id: string): Observable<CompanyWithFiles> {
    return this.http.get<CompanyWithFiles>(`${this.baseUrl}api/company/${id}`);
  }

  getCompanyStats(
    id: string,
    startDate?: Date,
    endDate?: Date,
  ): Observable<CompanyStats> {
    let params = new HttpParams();
    if (startDate && endDate) {
      params = params.set('startDate', startDate.toISOString());
      params = params.set('endDate', endDate.toISOString());
    }
    params = params.set('id', id);

    return this.http.get<CompanyStats>(
      `${this.baseUrl}api/company/stats-for-period`,
      {
        params,
      },
    );
  }

  searchCompanies(searchTerm: string) {
    let params = new HttpParams();
    params = params.set('searchTerm', searchTerm);

    return this.http.get<SearchCompanies>(`${this.baseUrl}api/company/search`, {
      params,
    });
  }

  getCompanyCount() {
    return this.http.get<number>(`${this.baseUrl}api/company/total-count`);
  }

  getPaginatedCompanies(
    page: number,
    pageSize: number,
    search: string,
    sortColumn?: string,
    sortDirection?: 'asc' | 'desc',
  ) {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('pageSize', pageSize.toString());

    if (search) {
      params = params.set('search', search);
    }
    if (sortColumn) {
      params = params.set('sortColumn', sortColumn);
    }
    if (sortDirection) {
      params = params.set('sortDirection', sortDirection);
    }

    return this.http.get<PaginatedCompanies>(
      `${this.baseUrl}api/company/paginated`,
      { params },
    );
  }
}
